var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowBg = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25757 10.5009C2.25757 14.3367 5.01466 17.7589 8.76904 18.5613C10.645 18.9622 12.6398 18.6921 14.3372 17.7977C15.9708 16.9369 17.291 15.5257 18.0393 13.8373C18.8177 12.0811 18.9534 10.0649 18.4225 8.21899C17.9105 6.43819 16.7868 4.8592 15.2784 3.78421C12.1248 1.53658 7.6951 1.83709 4.86934 4.48141C3.21328 6.03121 2.25757 8.23243 2.25757 10.5009ZM10.9404 6.54676L13.2416 8.79376C13.8244 9.36265 12.9415 10.2619 12.3615 9.69529L11.2004 8.5615L11.2004 13.9346C11.2004 14.3161 10.8818 14.6345 10.5005 14.6345C10.1191 14.6345 9.80056 14.3159 9.80056 13.9346L9.80056 8.58838L8.64451 9.74464C8.06995 10.3192 7.17892 9.42838 7.75348 8.85382L10.0551 6.55201C10.2989 6.30799 10.6937 6.30568 10.9404 6.54676Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowBg);
export default ForwardRef;